if (
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator
) {
  // navigator.serviceWorker
  //   .register('/_next/static/sw.js')
  //   .catch((e) => {
  //     console.error('Error during worker registration:', e);
  //   });

  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}
